import store from '../store'
import {isEmpty, get} from 'lodash';
import Wallkit from '../plugins/wallkit.esm.min.js';
import {getResourceCookie} from "../utils/resource";

export default async (to, from, next) => {

  const resourceFromQuery = get(to.query, 'PUBLIC_KEY');
  const resourceFromStore = store.getters['resource/resource_key'];
  const resourceFromCookie = getResourceCookie(resourceFromQuery);
  let currentResource = null;

  if (!isEmpty(resourceFromQuery)) {
    currentResource = resourceFromQuery;
  } else if (!isEmpty(resourceFromCookie) && resourceFromCookie !== resourceFromStore) {
    currentResource = resourceFromCookie
  } else {
    currentResource = resourceFromStore;
  }

  await store.dispatch('resource/updateResourceKey', {resource: currentResource, remember: true});

  Wallkit.init({
    resource: currentResource,
    api_url: process.env.BASE_URL,
  });

  const currentToken = Wallkit.getToken();

  if (!isEmpty(currentToken)) {
    await store.dispatch('auth/updateToken', {token: currentToken, remember: true});
  }

  next()

}



// WEBPACK FOOTER //
// ./src/middlewares/receive-resource-token.js